import RestClient from './RestClient';
import { EquipmentCatalogCategoryOrder } from '../../models';

class EquipmentCatalogCategoryOrders extends RestClient {
    constructor() {
        super({
            model: EquipmentCatalogCategoryOrder,
            entryPoint: 'equipment_catalog_category_order',
            resource: 'equipment_catalog_category_order',
            resources: 'equipment_catalog_category_orders',
            id_field: 'id',
            sortBy: 'sort_order'
        });
    }
}

const EquipmentCatalogCategoryOrdersApi = new EquipmentCatalogCategoryOrders();

export default EquipmentCatalogCategoryOrdersApi;
